import { ApolloLink, HttpLink, ApolloClient, from, InMemoryCache, useLazyQuery as useLazyQuery$1, useMutation as useMutation$1, useQuery as useQuery$1 } from '@apollo/client';
export { ApolloConsumer, ApolloError, ApolloProvider, InMemoryCache, NetworkStatus, defaultDataIdFromObject, gql, makeVar, useApolloClient, useReactiveVar, useSubscription } from '@apollo/client';
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries';
import { sha256 } from 'crypto-hash';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import * as React from 'react';
import { ApolloLink as ApolloLink$1 } from '@apollo/client/link/core';
import { MockLink, MockedProvider } from '@apollo/client/testing';
export { MockedProvider } from '@apollo/client/testing';
export * from 'graphql';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

// TODO: fix/improve token caching
// This is a hardcoded map of the queries and mutations that require authentication, when this
// map isn't in place, every single graphQL request will also send a request to
// check the session of auth0, this is a naive way to skip over all the graphQL
// queries which we know don't require authentication
var authOperations = [
    'CancelSubscription',
    'ChangeSubscription',
    'CreateStoredCardPayment',
    'CreateStoredSepaPaymentMethod',
    'findSubscription',
    'getSuspendSubscription',
    'getChangeSubscriptionPreview',
    'getCurrentSubscriptionDetails',
    'getPrescriptionDownloads',
    'getMyAppointments',
    'getMySubscriptions',
    'getSubscriptionDeliveries',
    'getSubscriptionPayments',
    'getSubscriptionPrescription',
    'getSubscriptionPrescriptionProducts',
    'getSubscriptionNotifications',
    'getSubscriptionProductRateplans',
    'getSuspensionResumeDates',
    'previewChangeSubscription',
    'ResumeSubscription',
    'RetrySubscriptionPayment',
    'SuspendSubscription',
    'UpdateBillingAddress',
    'UpdateDeliveryAddress',
    'UpdateSubscriptionPrescription',
    'storedPaymentMethods',
    'ChangePaymentMethod',
    'complete3DSChallengeFlowStoredPayment',
];
var authCallback = function (options) { return function (operation, previousRequest) {
    return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
        var requiresAuth, token, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requiresAuth = authOperations.some(function (name) { return name === operation.operationName; });
                    if (!requiresAuth || !options.getToken)
                        return [2 /*return*/, resolve(previousRequest)];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, options.getToken()];
                case 2:
                    token = _a.sent();
                    resolve({
                        headers: __assign(__assign({}, previousRequest.headers), { authorization: "Bearer " + token }),
                    });
                    return [3 /*break*/, 4];
                case 3:
                    e_1 = _a.sent();
                    reject(e_1);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); });
}; };
var authLink = function (options) { return setContext(authCallback(options)); };
var httpLink = function (options) {
    return new HttpLink(__assign({ credentials: 'same-origin', fetch: fetch }, options));
};
var errorLink = onError(function (_a) {
    var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
    if (graphQLErrors) {
        graphQLErrors.forEach(function (error) { return console.error("[GraphQL error]: " + error.message); });
    }
    if (networkError) {
        console.error('[Network error]:', networkError);
    }
});
var forwardHeaders = function (operation, forward) {
    var context = operation.getContext();
    var forwardHeaders = context.forwardHeaders;
    operation.setContext(function (_a) {
        var _b = _a.headers, headers = _b === void 0 ? {} : _b;
        return ({
            headers: __assign(__assign({}, headers), (forwardHeaders && forwardHeaders)),
        });
    });
    return forward(operation);
};
var forwardHeadersLink = new ApolloLink(forwardHeaders);

var apolloClient;
var initApolloClient = function (uri, options) {
    // Make sure to create a new client for every server-side request so that data
    // isn't shared between connections
    if (typeof window === 'undefined') {
        return createApolloClient(uri, options);
    }
    if (!apolloClient) {
        apolloClient = createApolloClient(uri, options);
    }
    return apolloClient;
};
var createApolloClient = function (uri, options) {
    if (options === void 0) { options = {}; }
    if (!uri) {
        console.error('No graphQL endpoint specified.');
        throw new Error('No graphQL endpoint specified.');
    }
    var cacheConfig = options.cacheConfig || {};
    var initialState = options.initialState || {};
    var queryOptions = options.queryOptions || {};
    var headers = {};
    var persistedQueriesLink = createPersistedQueryLink({ sha256: sha256, useGETForHashedQueries: true });
    return new ApolloClient({
        ssrMode: typeof window !== 'undefined',
        link: from(__spreadArray(__spreadArray([
            errorLink,
            forwardHeadersLink,
            authLink(options)
        ], __read((queryOptions.isPersistentQueryDisabled ? [] : [persistedQueriesLink]))), [
            httpLink({ headers: headers, uri: uri }),
        ])),
        cache: new InMemoryCache(__assign({ typePolicies: {
                LegacyProduct: {
                    keyFields: ['sku'],
                },
                Variant: {
                    keyFields: ['gan'],
                },
                ContactLensVariant: {
                    keyFields: ['gan'],
                },
                ContactLensProduct: {
                    keyFields: ['productMasterKey'],
                },
                SolutionVariant: {
                    keyFields: ['gan'],
                    fields: {
                        product: {
                            // Custom merge function tells apollo its safe to merge SolutionProducts which are direct descendants of SolutionVariants, this effectively uses the parent SolutionVariant 'gan' as the unique identifier for SolutionProduct
                            // https://www.apollographql.com/docs/react/caching/cache-field-behavior/#merging-non-normalized-objects
                            merge: function (existing, incoming) {
                                return __assign(__assign({}, existing), incoming);
                            },
                        },
                    },
                },
            } }, cacheConfig)).restore(initialState),
    });
};

var AccountActivationPayload = [
	"AccountActivatedSuccessfully",
	"CustomerAccountActivationMaxRetriesError"
];
var Address = [
	"BillingAddress",
	"DeliveryAddress"
];
var CompletedPaymentResultData = [
	"StoredPaymentErrorData",
	"StoredPaymentRefusedData",
	"StoredPaymentSuccessData"
];
var Domain = [
	"ContactLensProduct",
	"FrameProduct",
	"SolutionProduct",
	"SunglassesProduct"
];
var LineItem = [
	"LineItemBundle",
	"LineItemContactLenses",
	"LineItemRegular"
];
var Location = [
	"PickupPoint",
	"Store"
];
var MutationPayload = [
	"CompletePaymentPayload",
	"StoredPaymentMethodMutationPayload"
];
var MutationResponse = [
	"CartMutationResponse",
	"ShareCartMutationResponse",
	"TicketMutationResponse"
];
var PaymentTransactionMethod = [
];
var Prescription = [
	"PrescriptionDownload"
];
var Product = [
	"ContactLensProduct",
	"FrameProduct",
	"SolutionProduct",
	"SunglassesProduct"
];
var RatePlan = [
	"ContactLensRatePlan",
	"SolutionRatePlan"
];
var RecommendationBannerAction = [
	"RecommendationBannerApplyDiscountCodeAction",
	"RecommendationBannerRedirectToLinkAction"
];
var RecommendationProductAction = [
	"RecommendationProductAddToCartAction",
	"RecommendationProductRedirectAction"
];
var StoreGroupInterface = [
	"SingleStoreGroup",
	"StoreGroup"
];
var StoredPaymentMethod = [
	"StoredCardPaymentMethod",
	"StoredSEPAPaymentMethod"
];
var StoredPaymentMethodResult = [
	"StoredCardPaymentMethod",
	"StoredSEPAPaymentMethod"
];
var StoredPaymentResult = [
	"Payment3DSChallengeData",
	"PaymentRedirectData",
	"StoredPaymentErrorData",
	"StoredPaymentRefusedData",
	"StoredPaymentSuccessData"
];
var StoredPaymentResultData = [
	"Payment3DSChallengeData",
	"PaymentRedirectData",
	"StoredPaymentErrorData",
	"StoredPaymentRefusedData",
	"StoredPaymentSuccessData"
];
var SubscriptionProductVariant = [
	"ContactLensVariant",
	"SolutionVariant"
];
var SubscriptionStoredPaymentMethod = [
	"StoredCardPaymentMethod",
	"StoredSEPAPaymentMethod"
];
var TypeDetails = [
	"BundleNonPrescriptionBundleTypeDetails",
	"BundlePrescriptionGlassesTypeDetails",
	"ContactLensBundleBeneluxTypeDetails",
	"ContactLensSubscriptionTypeDetails",
	"ContactLensesTypeDetails",
	"RegularTypeDetails"
];
var Variant = [
	"ContactLensVariant",
	"FrameVariant",
	"SolutionVariant",
	"SunglassesVariant"
];
var possibleTypes = {
	AccountActivationPayload: AccountActivationPayload,
	Address: Address,
	CompletedPaymentResultData: CompletedPaymentResultData,
	Domain: Domain,
	LineItem: LineItem,
	Location: Location,
	MutationPayload: MutationPayload,
	MutationResponse: MutationResponse,
	PaymentTransactionMethod: PaymentTransactionMethod,
	Prescription: Prescription,
	Product: Product,
	RatePlan: RatePlan,
	RecommendationBannerAction: RecommendationBannerAction,
	RecommendationProductAction: RecommendationProductAction,
	StoreGroupInterface: StoreGroupInterface,
	StoredPaymentMethod: StoredPaymentMethod,
	StoredPaymentMethodResult: StoredPaymentMethodResult,
	StoredPaymentResult: StoredPaymentResult,
	StoredPaymentResultData: StoredPaymentResultData,
	SubscriptionProductVariant: SubscriptionProductVariant,
	SubscriptionStoredPaymentMethod: SubscriptionStoredPaymentMethod,
	TypeDetails: TypeDetails,
	Variant: Variant
};

var DebugMockedProvider = function (_a) {
    var children = _a.children, mocks = _a.mocks, addPossibleTypes = _a.addPossibleTypes, rest = __rest(_a, ["children", "mocks", "addPossibleTypes"]);
    var mockLink = new MockLink(mocks || []);
    var link = ApolloLink$1.from([errorLink, mockLink]);
    return (React.createElement(MockedProvider, __assign({ cache: new InMemoryCache(addPossibleTypes
            ? {
                possibleTypes: possibleTypes,
            }
            : {}), addTypename: false, link: link }, rest), children));
};

var wait = function (ms) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    return [2 /*return*/, new Promise(function (resolve) { return setTimeout(resolve, ms); })
        // Find the given errorCode, when facing an internal server error, the errorcode can be found within the original error
    ];
}); }); };
// Find the given errorCode, when facing an internal server error, the errorcode can be found within the original error
var getGraphQLErrorCode = function (error, errorCode) {
    return error.graphQLErrors.find(function (error) {
        var _a, _b;
        return ((_a = error.extensions) === null || _a === void 0 ? void 0 : _a.code) === errorCode ||
            ((_b = error.extensions) === null || _b === void 0 ? void 0 : _b.exception.originalError.extensions.code) === errorCode;
    });
};

var getOperationInfo = function (query) {
    var operationNode = query.definitions[0];
    var name = 'anonymous';
    // Fallback name when the operation has been malformed but still send to the BE
    var type = operationNode.kind;
    if (operationNode.kind === 'OperationDefinition') {
        type = operationNode.operation;
        if (operationNode.name) {
            name = operationNode.name.value;
        }
    }
    return [type, name];
};
var handleError = function (query, error) {
    var graphQLErrors = error.graphQLErrors;
    var Sentry = window.Sentry;
    var _a = __read(getOperationInfo(query), 2), type = _a[0], name = _a[1];
    // logging package does not have scope or capture exceptions as of yet.
    if (Sentry) {
        if (graphQLErrors.length) {
            Sentry.withScope(function (scope) {
                scope.setTag('type', 'graphql');
                Sentry.captureException(error);
            });
        }
        else {
            Sentry.captureException(error);
        }
    }
    console.error("[" + type + "] - " + name + " - error", { error: error });
};

var useLazyQuery = function (query, options) {
    var _a = __read(useLazyQuery$1(query, options), 2), executable = _a[0], result = _a[1];
    var error = result.error;
    React.useEffect(function () {
        if (error) {
            handleError(query, error);
        }
    }, [error, query]);
    return [executable, result];
};

var useMutation = function (mutation, options) {
    var _a = __read(useMutation$1(mutation, options), 2), executable = _a[0], result = _a[1];
    var error = result.error;
    React.useEffect(function () {
        if (error) {
            handleError(mutation, error);
        }
    }, [error, mutation]);
    return [executable, result];
};

/**
 * This hooks allows for paginated GraphQL queries. It will return the data
 * in a paged format, meaning you get an array containing arrays of
 * length `pageSize`.
 *
 * How to use the pages is up to you.
 *
 * The hook is type-safe, types for both the data returned from the query, as
 * well as the actual paginatable data is provided through generics.
 * @param query GraphQL query with pagination support
 * @param pageSize Amount of items per page
 * @param pagedDataSelector Selector to get to paginatable data
 * @param options Optional, query variables
 * @returns [{total, pages}, fetchMore, loading, error]
 * @example
 * const [{ total, pages }, fetchNext, loading, error] = usePaginatedQuery<
 *   getMyOrderHistory,
 *   getMyOrderHistory_me_orders_results
 * >(GET_MY_ORDER_HISTORY, 5, (result) => result.me?.orders)
 */
function usePaginatedQuery(query, pageSize, pagedDataSelector, options) {
    var _a = __read(React.useState({
        offset: 0,
        limit: pageSize,
    }), 2), pageCursor = _a[0], setPageCursor = _a[1];
    var _b = __read(React.useState(0), 2), total = _b[0], setTotal = _b[1];
    var _c = __read(React.useState(null), 2), pages = _c[0], setPages = _c[1];
    var _d = __read(useLazyQuery$1(query, {
        variables: __assign(__assign({}, options), pageCursor),
    }), 2), executable = _d[0], _e = _d[1], data = _e.data, loading = _e.loading, error = _e.error;
    var fetchNext = React.useCallback(function () {
        var newCursor = __assign(__assign({}, pageCursor), { offset: pageCursor.offset + pageSize });
        setPageCursor(newCursor);
        executable({
            variables: __assign(__assign({}, options), newCursor),
        });
    }, [executable, options, pageCursor, pageSize]);
    React.useEffect(function () {
        if (error) {
            handleError(query, error);
        }
    }, [error, query]);
    /**
     * Append data coming in from a fetch to the existing
     * array of pages
     */
    React.useEffect(function () {
        if (!data) {
            return;
        }
        var paginatedData = pagedDataSelector(data); //extract paginated data
        if ((paginatedData === null || paginatedData === void 0 ? void 0 : paginatedData.results) && !loading && !error) {
            setPages(function (pages) {
                return pages === null ? [paginatedData.results] : pages.concat([paginatedData.results]);
            });
            setTotal(paginatedData.total);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);
    /**
     * Initial fetch
     */
    React.useEffect(function () {
        if (pages === null && !loading && !error) {
            executable();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return React.useMemo(function () {
        return [
            { fetchNext: fetchNext },
            {
                data: {
                    total: total,
                    pages: pages !== null && pages !== void 0 ? pages : [[]],
                },
                loading: loading,
                error: error,
            },
        ];
    }, [fetchNext, total, pages, loading, error]);
}

var useQuery = function (query, options) {
    var result = useQuery$1(query, options);
    var error = result.error;
    React.useEffect(function () {
        if (error) {
            handleError(query, error);
        }
    }, [error, query]);
    return result;
};

export { DebugMockedProvider, getGraphQLErrorCode, initApolloClient, useLazyQuery, useMutation, usePaginatedQuery, useQuery, wait };
//# sourceMappingURL=index.js.map
